import axios from "axios";

export default async function checkFilesExplorer(projectName) {
    const res = await axios.get(`/project/${projectName}/check-files-explorer`)
    return res;
}